import defaultReducer from './defaultReducer';
import { defaultGrid } from '../../helpers/datagrid';

export default defaultReducer(
    'COLLECTION_BREAKDOWN_MODAL',
    { 
        comments: [],
        loading: false,
        open: false,
        detailGrid: defaultGrid,
        meterGrid: defaultGrid,
        collectionPeriod: defaultGrid,
        interimCollections: defaultGrid,
        varianceHistory: defaultGrid,
        transactionsGrid: defaultGrid,
        eventsGrid: defaultGrid,
        siteText: "Rimini Test lab A, Chester",
        weekText: "10 - Aug 1st - Aug 9th",
        egmText: "[54] - Lucky Dip, Rimini",
        showEventsGrid: false,
        showMetersGrid: true,
        showTicketsGrid: true,
        ticketsGrid: defaultGrid,
        showMetersGridInterim: true,
        optionShowExport: false,
        optionShowVariance: false,
        optionShowVarianceHistory: false,
        onRefresh: () => { }
    }
)